import React, {useState, useEffect, useRef} from "react";
import * as palette from "../Variables";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Placeholder from "../img/placeholder.jpg";
import styled from "styled-components";
import WorkHero from "../components/WorkHero";
import Insight from "../components/Insight";
import Competitor from "../components/Competitor";
import PainPoint from "../components/PainPoint";
import StickyNav from "../components/StickyNav";
import Persona from "../components/Persona";
import WorkRecommendation from "../components/WorkRecommendation";
import HeroImgDesktop from "../img/southwest/southwest-hero-desktop.png";
import HeroImgMobile from "../img/southwest/southwest-hero-mobile.png";
import DesignProcess from "../img/design-process.png";
import Competitor1 from "../img/southwest/southwest-competitor-1.png";
import Competitor2 from "../img/southwest/southwest-competitor-2.png";
import Competitor3 from "../img/southwest/southwest-competitor-3.png";
import Competitor4 from "../img/southwest/southwest-competitor-4.png";
import TargetAudiencePink from "../img/target-audience-pink.png";
import TargetAudienceOrange from "../img/target-audience-orange.png";
import TargetAudienceBlue from "../img/target-audience-blue.png";
import UserJourneyFlightStatusDesktop from "../img/southwest/user-journey-flight-status-desktop.png";
import UserJourneyFlightStatusMobile from "../img/southwest/user-journey-flight-status-mobile.png";
import UserJourneyBookFlightDesktop from "../img/southwest/user-journey-book-flight-desktop.png";
import UserJourneyBookFlightMobile from "../img/southwest/user-journey-book-flight-mobile.png";
import Sketches from "../img/southwest/southwest-sketches.png";
import Original from "../img/southwest/southwest-original.png";
import Wireframes from "../img/southwest/southwest-wireframes.png";
import Final from "../img/southwest/southwest-final.png";
import Persona1 from "../img/southwest/southwest-persona-1.png";
import Persona2 from "../img/southwest/southwest-persona-2.png";
import DignifiThumbnail from "../img/dignifi/dignifi-thumbnail.png";
import SmartHomeThumbnail from "../img/smart-home/smart-home-thumbnail.png";
import InsightThumbnail from "../img/insight/insight-thumbnail.jpg";


const WorkSection = styled.section`
    padding-top: 44px;
    padding-bottom: 44px;
    padding-left: 16px;
    padding-right: 16px;
    display: flex;
    flex-flow: column nowrap;
    row-gap: 44px;

    &.grey {
        background-color: ${palette.neutral2};
    }

    &.challenge {
        background: ${palette.gradientMain};

        p, h2 {
            color: ${palette.neutral1};
        }

        p.description {
            font-size: 22px;
        }
    }

    .work-recommendation-container {
        width: 100%;

        @media (min-width: 400px) {
            width: 48%;
        }

        @media (min-width: 650px) {
            width: 32%;
        }
    }

    a:focus-visible {
        outline: 3px solid ${palette.blueMain};
        outline-offset: 8px;
        border-radius: 4px;
    }

    .container.main-container {
        @media (min-width: 1200px) {
            margin-left: 250px;
        }

        @media (min-width: 1600px) {
            margin-left: auto;
        }
    }

    &.reflections {
        background: ${palette.blueMain};

        .label, .h3, p.h4, p {
            color: ${palette.neutral1};
        }

        .summary {
            margin-bottom: 40px;
        }
    }

    .no-left-padding, .no-right-padding {
        padding-left: 0;
        padding-right: 0;
    }

    .h3, .section-title {
        margin-bottom: 16px;
    }

    .img-caption {
        color: ${palette.neutral9};
        margin-bottom: 0 !important;
        margin-top: 16px;
    }

    img {
        border-radius: 8px;
    }

    img.placeholder {
        aspect-ratio: 2/1;
    }

    @media (min-width: 768px) {
        padding-top: 72px;
        padding-bottom: 72px;
        padding-left: 24px;
        padding-right: 24px;
        row-gap: 72px;

        .no-left-padding {
            padding-left: 0;
        }

        .no-right-padding {
            padding-right: 0;
        }

        .h3, .section-title {
            margin-bottom: 24px;
        }
    }

    @media (min-width: 1200px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1300px) {
        &.first {
            margin-top: -456px;
        }
    }

    @media (min-width: 1400px) {
        &.first {
            margin-top: -456px;
        }
    }

    .work-elements {
        row-gap: 24px;
        display: flex;
        flex-flow: column nowrap;

        &.overview {
            h1 {
                margin-bottom: 12px;
            }
        }

        @media (min-width: 768px) {
            row-gap: 52px;

            &.overview {
                h1 {
                    margin-bottom: 24px;
                }
            }
        }

        @media (min-width: 1200px) {
            max-width: 850px;
        }

        @media (min-width: 1250px) {
            max-width: 900px;
        }

        @media (min-width: 1300px) {
            max-width: 940px;
        }

        @media (min-width: 1400px) {
            max-width: 1040px;
        }

        @media (min-width: 1500px) {
            max-width: 1096;
        }


        .neutral-9 {
            color: ${palette.neutral9};
        }

        .competitors-container {
            display: flex;
            flex-flow: row wrap;
            column-gap: 20px;
            row-gap: 16px;

            @media (min-width: 768px) {
                column-gap: 60px;
                row-gap: 24px;
            }
        }

        .insights-container {
            display: flex;
            flex-flow: column nowrap;
            row-gap: 28px;
        }

        .pain-points-container {
            row-gap: 20px;
            display: flex;
            flex-flow: column nowrap;

            @media (min-width: 768px) {
                row-gap: 32px;
            }
        }

        .left {
            @media (min-width: 768px) {
                padding-right: 24px;
            }
        }

        .right {
            @media (min-width: 768px) {
                padding-left: 24px;
            }
        }

        h3.audience1 {
            margin-bottom: 12px;

            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }

        h3.audience2 {
            margin-top: 40px;
            margin-bottom: 12px;
            
            @media (min-width: 768px) {
                margin-top: 0;
                margin-bottom: 16px;
            }
        }
    }

    .personas-container {
        display: flex;
        flex-flow: column nowrap;
        row-gap: 40px;

        @media (min-width: 768px) {
            row-gap: 64px;
        }
    }
`;

const persona1Demographics = (
    <div>
        <p style={{marginBottom: 4}}><span>Age: </span>53 years old<br/></p>
        <p style={{marginBottom: 4}}><span>Occupation: </span>Sales manager<br/></p>
        <p style={{marginBottom: 4}}><span>Location: </span>Chicago, Illinois<br/></p>
        <p style={{marginBottom: 4}}><span style={{lineHeight: 1.5}}>Travel frequency: </span>3 times per month</p>
    </div>
);

const persona1Interests = (
    <ul>
        <li>Getting to her destination quickly with minimal hassle</li>
        <li>Loyalty programs and travel perks</li>
    </ul>
);

const persona1Aspirations = (
    <ul>
        <li>"I want to streamline every part of my travel experience when I'm traveling for work."</li>
        <li>"I'd like to achieve the highest status that Southwest offers."</li>
    </ul>
);

const persona1Frustrations = (
    <ul>
        <li>Missing flights due to misunderstandings or poor communication</li>
        <li>Clunky booking processes waste time</li>
    </ul>
);

const persona2Demographics = (
    <div>
        <p style={{marginBottom: 4}}><span>Age: </span>72 years old<br/></p>
        <p style={{marginBottom: 4}}><span>Occupation: </span>Retired<br/></p>
        <p style={{marginBottom: 4}}><span>Location: </span>Dallas, Texas<br/></p>
        <p style={{marginBottom: 4}}><span style={{lineHeight: 1.5}}>Travel frequency: </span>Less than once per year</p>
    </div>
);

const persona2Interests = (
    <ul>
        <li>Checking in on his loved ones’ schedules</li>
        <li>Using his phone mainly for texting, photos, and basic apps</li>
    </ul>
);

const persona2Aspirations = (
    <ul>
        <li>"I want to see if the weather has delayed my sister's flight."</li>
        <li>"I am picking up my sister from the airport, so I want to be sure I can trust her flight's scheduled arrival time."</li>
    </ul>
);

const persona2Frustrations = (
    <ul>
        <li>Flight tracking that isn't easy to understand</li>
        <li>Too many irrelevant options cluttering his experience</li>
    </ul>
);

const SouthwestAppRedesign = () => {

    const [scrollY, setScrollY] = useState(window.scrollY);

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const getScrollMarginTop = (ref) => {
        if (!ref.current) return 0;
        const sectionTop = ref.current.getBoundingClientRect().top + window.scrollY;
        return sectionTop > scrollY ? 0 : 135;
    };

    const overviewRef = useRef(null);
    const generalResearchRef = useRef(null);
    const userResearchRef = useRef(null);
    const challengeRef = useRef(null);
    const analysisRef = useRef(null);
    const iterationsRef = useRef(null);
    const finalDesignRef = useRef(null);
    const reflectionsRef = useRef(null);

    const [matches, setMatches] = useState(
        window.matchMedia("(min-width: 768px)").matches
    )

    const [showHeader, setShowHeader] = useState(true);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1200);
    const lastScrollY = useRef(window.scrollY);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            const isScrollingUp = currentScrollY < lastScrollY.current;
            const isAtTop = currentScrollY < 10;
            const threshold = isDesktop ? 135 : 66;

            if (isScrollingUp || isAtTop) {
                setShowHeader(true);
            } else if (currentScrollY > threshold) {
                setShowHeader(false);
            }
            lastScrollY.current = currentScrollY;
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isDesktop]);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 1200);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const stickyBase = 72;
    const headerHeight = 135;
    const stickyOffset = showHeader ? stickyBase + headerHeight : stickyBase;

    useEffect(() => {
        window
        .matchMedia("(min-width: 768px)")
        .addEventListener('change', e => setMatches( e.matches ));
    }, []);


        <div >
        {matches && (<h1>Big Screen</h1>)}
        {!matches && (<h3>Small Screen</h3>)}
        </div>

    return (
        <main>

            <WorkHero src={HeroImgDesktop} alt={"Screens in the 'book a flight' flow of the redesigned Southwest Airlines app"} className={"d-none d-lg-block"}></WorkHero>
            <WorkHero src={HeroImgMobile} alt={"Screens in the 'book a flight' flow of the redesigned Southwest Airlines app"} className={"d-lg-none"}></WorkHero>
            <div className={"page-container"}>
                <StickyNav headerOffset={stickyOffset} />
                <WorkSection className={"first"} id="overview" ref={overviewRef} style={{scrollMarginTop: getScrollMarginTop(overviewRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements overview"}>
                                    <div>
                                        <h1 className={"h2"}>Southwest Airlines app redesign (concept)</h1>
                                        <p><span className={"semibold"}>Timeline / </span>Spring 2024</p>
                                        <p><span  className={"semibold"}>Involvement / </span>Independent UX researcher and designer</p>
                                        <p><span  className={"semibold"}>Deliverables / </span>New design for "book a flight" and "check flight status" user flows</p>
                                        <p><span  className={"semibold"}>UX activities / </span>User flows, personas, usability testing</p>
                                        <p><span  className={"semibold"}>Tools used / </span>Figma, Miro, pen and paper</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Overview</p>
                                        <h2 className={"h3"}>Background</h2>
                                        <p>The current Southwest Airlines app features outdated graphics, inadequate navigation, and unnecessary features that add noise for the user.</p>
                                        <p style={{margin:0}}>With an update to the Southwest Airlines app, users experience streamlined processes for booking flights and checking flight statuses.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container d-none d-md-block"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Design process</h2>
                                        <img src={DesignProcess} alt={"Design process: brainstorm, research, analysis, design, user testing, delivery; contains multiple iterations of analysis, design, and user testing."} style={{maxWidth: 900, borderRadius: 0}}></img>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection className={"grey"} id={"general-research"} ref={generalResearchRef} style={{scrollMarginTop: getScrollMarginTop(generalResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>General research</p>
                                        <h2 className={"h3"}>Target audiences</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                <div className={"insights-container"}>
                                                    <Insight
                                                        number={"01"}
                                                        title={"Travelers"}
                                                        description={"People seeking low-cost airfare without extra frills"}>
                                                    </Insight>
                                                    <Insight
                                                        number={"02"}
                                                        title={"Loved ones"}
                                                        description={"People tracking their friends' and family members' flights"}>
                                                    </Insight>
                                                </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <h2 className={"h3"}>Competitors</h2>
                                <div className={"work-elements"}>
                                    <div className={"competitors-container"}>
                                        <Competitor
                                            src={Competitor1}
                                            alt={""}
                                            name={"American Airlines"}>
                                        </Competitor>
                                        <Competitor
                                            src={Competitor2}
                                            alt={""}
                                            name={"United Airlines"}>
                                        </Competitor>
                                        <Competitor
                                            src={Competitor3}
                                            alt={""}
                                            name={"Delta Airlines"}>
                                        </Competitor>
                                        <Competitor
                                            src={Competitor4}
                                            alt={""}
                                            name={"Expedia"}>
                                        </Competitor>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>

                <WorkSection id={"user-research"} ref={userResearchRef} style={{scrollMarginTop: getScrollMarginTop(userResearchRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>User research</p>
                                        <h2 className={"h3"}>Pain points</h2>
                                        <Container>
                                            <Row >
                                                <Col xs={12} md={6} className={"col-md-left"}>
                                                    <h3 className={"h4 audience1"}>Travelers</h3>
                                                    <div className={"pain-points-container"}>
                                                        <PainPoint
                                                            src={TargetAudiencePink}
                                                            alt={""}
                                                            quote1={"“There are so many options and I don't know where to start. "}
                                                            semibold={"I'm overwhelmed"}
                                                            quote2={".”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceOrange}
                                                            alt={""}
                                                            quote1={"“This is my first time booking a flight. "}
                                                            semibold={"I don't know what to focus on"}
                                                            quote2={" when I'm choosing a flight.”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceBlue}
                                                            alt={""}
                                                            quote1={"“I'm on a tight budget. I "}
                                                            semibold={"only want to see flights in my price range"}
                                                            quote2={".”"}
                                                        ></PainPoint>
                                                    </div>
                                                </Col>
                                                <Col xs={12} md={6} className={"col-md-right"}>
                                                    <h3 className={"h4 audience2"}>Loved ones</h3>
                                                    <div className={"pain-points-container"}>
                                                        <PainPoint
                                                            src={TargetAudienceOrange}
                                                            alt={""}
                                                            quote1={"“I just want to know when my son's flight is going to land. "}
                                                            semibold={"I don't want to click a bunch of buttons "}
                                                            quote2={"to get there.”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudienceBlue}
                                                            alt={""}
                                                            quote1={"“I have family coming from all over, and I'm "}
                                                            semibold={"struggling to track each person's flight easily"}
                                                            quote2={".”"}
                                                        ></PainPoint>
                                                        <PainPoint
                                                            src={TargetAudiencePink}
                                                            alt={""}
                                                            quote1={"“I don't fly much, so it's  "}
                                                            semibold={"intimidating to find what I need"}
                                                            quote2={" in this new app.”"}
                                                        ></PainPoint>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Personas</h2>
                                        <div className={"personas-container"}>
                                            <Persona src={Persona1} alt={""} name={"Jacqueline"} personaType={"Traveler"} className={"interests aspirations frustrations"} demographics={persona1Demographics} interests={persona1Interests} aspirations={persona1Aspirations} frustrations={persona1Frustrations}>
                                            </Persona>
                                            <Persona src={Persona2} alt={""} name={"Oscar"} personaType={"Loved one"} className={"interests aspirations frustrations"} demographics={persona2Demographics} interests={persona2Interests} aspirations={persona2Aspirations} frustrations={persona2Frustrations}>
                                            </Persona>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Initial user testing insights</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Confusing navigation"}
                                                            description={"Users were confused by the complex navigation and didn't know what to do on screens when it wasn't present."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Outdated feel"}
                                                            description={"Users noted that the app felt outdated and made them question the brand's reliability."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"03"}
                                                            title={"Difficulty completing tasks"}
                                                            description={"The steps required to complete certain tasks were unnecessarily complicated, leading to frustration for users."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"challenge"} className={"challenge dark-background"} ref={challengeRef} style={{scrollMarginTop: getScrollMarginTop(challengeRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12} lg={9}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Challenge</p>
                                        <h2 className={"h3"}>Problem statement</h2>
                                        <p className={"no-margin description"}>A confusing navigation and lack of information hierarchy causes frustration. Users desire simplicity and pleasing design.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id="analysis" className={"grey"} ref={analysisRef} style={{scrollMarginTop: getScrollMarginTop(analysisRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Analysis</p>
                                        <h2 className={"h3"}>User flows</h2>
                                        <h3 className={"h4"}>Booking a flight</h3>

                                        <img src={UserJourneyBookFlightDesktop}alt={""} style={{borderRadius:0, marginBottom: 48}} className={"d-none d-md-block"}></img>

                                        <img src={UserJourneyBookFlightMobile} alt={""} style={{borderRadius:0, maxWidth: 242, marginTop: 12, marginBottom: 36}} className={"d-md-none"}></img>

                                        <div className={"sr-only"}>
                                            <p>In the "book a flight" user flow, users open the app, select "book a flight," and then can either pick "round trip" or "one way." Then, they enter their flight details, potentially including a promo code or their SWABIZ information, and select "find flights." From there, they choose their flights, pick their fare, confirm details, and check out.</p>
                                        </div>

                                        <h3 className={"h4"}>Checking flight status</h3>

                                        <img src={UserJourneyFlightStatusDesktop} alt={""} style={{borderRadius:0, maxWidth: 940}} className={"d-none d-md-block"}></img>

                                        <img src={UserJourneyFlightStatusMobile} alt={""} style={{borderRadius:0, maxWidth: 300, marginTop: 12}} className={"d-md-none"}></img>

                                        <div className={"sr-only"}>
                                            <p>In the "check flight status" user flow, users open the app and select "flight status." They can either use the default "search" tab or they can select the "recent searches" tab. Then, they either select which recent search to use or enter the airport and date (and potentially the flight number). After clicking "search," they can then select the specific flight if necessary and view details. From there, they can select "refresh," share the flight status information, or go back to the home screen of the app (or anywhere else in the navigation).</p>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"iterations"} className={"design-iterations"} ref={iterationsRef} style={{scrollMarginTop: getScrollMarginTop(iterationsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Design iterations</p>
                                        <h2 className={"h3"}>Original app<sup>*</sup></h2>
                                        <img src={Original} alt={""}></img>
                                        <p className={"img-caption margin-bottom-16"}>Original Southwest Airlines app that my redesign is based on.</p>
                                        <p className={"img-caption"}><sup>*</sup>Southwest Airlines redesigned their app after the completion of this project. Any similarities between their current app and my final design are purely coincidental :)</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Sketches</h2>
                                        <img src={Sketches} alt={""} style={{borderRadius: 0}}></img>
                                        <p className={"img-caption"}>Sketches of the home screen and the "book a flight" and "flight status" user flows.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>High-fidelity wireframes</h2>
                                        <img src={Wireframes} alt={""}></img>
                                        <p className={"img-caption"}>High-fidelity wireframes of the home screen and the "book a flight" and "flight status" user flows.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h3 className={"h4 section-title"}>User testing insights</h3>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Issues with font and tap target sizes"}
                                                            description={"Tap targets and font sizes were too small for users to comfortably interact with certain elements."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Assumption of errors"}
                                                            description={"Some users initially assumed that the color choices in the fare selection were implying that an error had occurred."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"03"}
                                                            title={"Distractions in header"}
                                                            description={"The use of large sections of red and yellow in the header was distracting, taking attention away from the main content."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"final-design"} className={"final-design grey"} ref={finalDesignRef} style={{scrollMarginTop: getScrollMarginTop(finalDesignRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Final design</p>
                                        <h2 className={"h3"}>Final deliverables</h2>
                                        <img src={Final} alt={""}></img>
                                        <p className={"img-caption"}>Final design of the home screen and the "book a flight" and "flight status" user flows, including open and closed states for menu and sharing options.</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h3 className={"h4 section-title"}>Changes made from previous iterations</h3>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"insights-container no-title"}>
                                                        <Insight
                                                            number={"01"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={"Increased font and tap target sizes for accessibility."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={"Made slight changes to UI, including a redesign of the header and buttons to reduce distractions and create balance visually."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"03"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={"Condensed home screen elements to fit on the screen without scrolling."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"04"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={"Changed filter icon to sort icon to reduce confusion."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"05"}
                                                            className={"no-title"}
                                                            title={null}
                                                            description={"Removed background color from fare selection boxes and switched to a bottom border to underscore differences in fares."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection id={"reflections"} className={"reflections dark-background"} ref={reflectionsRef} style={{scrollMarginTop: getScrollMarginTop(reflectionsRef)}}>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <p className={"label"}>Reflections</p>
                                        <h2 className={"h3"}>What I learned</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <p className="summary">This project was my first step into redesigning a complex app with many different functionalities and motivations for interacting with the app. While I didn't dive into every area of the app in this redesign, I enjoyed the challenge of reorganizing the navigation and information hierarchy to suit the needs of several audiences at once.</p>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Balancing old with new"}
                                                            description={"Redesigning an existing product requires a careful balance between preserving familiar interactions for loyal users and introducing modern improvements."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Reducing cognitive load"}
                                                            description={"After analyzing the current Southwest Airlines app, I was able to prioritize sections in a way that kept options in groups of 5 or fewer, simplifying choices for users."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Future considerations</h2>
                                        <Container>
                                            <Row>
                                                <Col xs={12} lg={9}>
                                                    <div className={"insights-container"}>
                                                        <Insight
                                                            number={"01"}
                                                            title={"Calendar integration"}
                                                            description={"Integrations with the user’s calendar to find scheduled trips and make flight suggestions would better support the users' needs."}>
                                                        </Insight>
                                                        <Insight
                                                            number={"02"}
                                                            title={"Search-sharing capabilities"}
                                                            description={"Giving users an option to share a flight search with their travel buddies would help them collaborate on travel plans more effectively."}>
                                                        </Insight>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
                <WorkSection className={"recommendations"} id="reflections">
                    <Container className={"main-container"}>
                        <Row>
                            <Col xs={12}>
                                <div className={"work-elements"}>
                                    <div>
                                        <h2 className={"h3"}>Explore other projects</h2>
                                        <Container>
                                            <Row style={{rowGap: 24, justifyContent: "space-between"}}>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={DignifiThumbnail}
                                                        alt={"Three screens from the Dignifi app"}
                                                        title={"Dignifi"}
                                                        description={"App design"}
                                                        href={"/dignifi-app-design"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={InsightThumbnail}
                                                        alt={"Prototype of the InSight AR device and one screen from the InSight app"}
                                                        title={"InSight"}
                                                        description={"AR experience and app design"}
                                                        href={"/insight-ar-app-design"}>
                                                    </WorkRecommendation>
                                                </Col>
                                                <Col xs={12} sm={6} md={4} lg={3} className={"work-recommendation-container"}>
                                                    <WorkRecommendation
                                                        src={SmartHomeThumbnail}
                                                        alt={"Mobile and desktop views of the Renesas Smart Home infographic"}
                                                        title={"Renesas Smart Home"}
                                                        description={"Interactive infographic"}
                                                        href={"/smart-home-infographic"}>
                                                    </WorkRecommendation>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </WorkSection>
            </div>
        </main>
    )
}

export default SouthwestAppRedesign;